import {
  CategoryLeaderboardViewState,
  OpportunityReviewViewState,
  PerformanceAnalysisViewState,
  ProductsViewState,
  TradingAssistantViewState,
} from '@models/SavedViews';
import { CopySavedViewLinkButton } from '@ecosystem/newron-client-lib';
import React from 'react';
import { SavedViewButtonsTrackingTags } from '@ecosystem/newron-client-lib/build/saved-views/types';

interface Props {
  createViewFunction: () =>
    | PerformanceAnalysisViewState
    | CategoryLeaderboardViewState
    | ProductsViewState
    | OpportunityReviewViewState
    | TradingAssistantViewState;
  copyViewTracking: () => SavedViewButtonsTrackingTags;
}

const CreateCopyViewButton: React.FC<Props> = ({ createViewFunction, copyViewTracking }) => {
  return <CopySavedViewLinkButton createViewStateFn={createViewFunction} getTrackingTags={copyViewTracking} />;
};

export default CreateCopyViewButton;
